// DashboardWidgetRenderer.tsx
import type { ComponentType } from "react";
import type { DashboardLayoutMenuDetail } from "@/app/types/alterNativeDashboardLayout";

export interface DashboardWidgetProps {
  title?: string;
  isMandatory?: string;
}

export type DashboardWidgetRegistry = Record<number, ComponentType<any>>;

interface DashboardWidgetRendererProps {
  menuDetail: DashboardLayoutMenuDetail[];
  registry: DashboardWidgetRegistry;
  extraProps?: Record<number, Record<string, any>>;
}

const DashboardWidgetRenderer = ({
  menuDetail,
  registry,
  extraProps,
}: DashboardWidgetRendererProps) => {
  const visibleWidgets = menuDetail
    .filter((menu) => {
      if (menu.recordState !== "A") return false;
      if (!registry[menu.menuId]) {
        console.warn(
          `DashboardWidgetRenderer: no widget registered for menuId ${menu.menuId} (${menu.menuLabelName})`,
        );
        return false;
      }
      return true;
    })
    .sort((a, b) => a.orderSequence - b.orderSequence);

  return (
    <>
      {visibleWidgets.map((menu) => {
        const Widget = registry[menu.menuId];
        return (
          <Widget
            key={menu.menuId}
            title={menu.menuLabelName}
            isMandatory={menu.isMandatory}
            {...(extraProps?.[menu.menuId] ?? {})}
          />
        );
      })}
    </>
  );
};

export default DashboardWidgetRenderer;
